////////////////////////////////////////////////////////////////////////////////
//                                                                            //
//  IRONSIDE - Public Website GUI                                             //
//                                                                            //
//  Version: 1.0.3                                                            //
//  Summary: Scroll-past-threshold hook — drives the header's blurred pill    //
//           backdrop once the hero has scrolled out of view (1.0.3.md §3)   //
//                                                                            //
////////////////////////////////////////////////////////////////////////////////
//
//  A genuine subscription to an external system (the document's scroll
//  position), so an effect is the correct tool — not a case of copying a prop
//  into state. `passive: true` matches the read-only, non-preventDefault use
//  here (same convention `config.tsx`'s resize listener would use if it needed
//  to opt in explicitly).
//
////////////////////////////////////////////////////////////////////////////////

import { useEffect, useState } from 'react';

/** True once `window.scrollY` exceeds `threshold` (px). Checked once at mount
 * (a reload deep-scrolled via anchor/back-forward cache should not flash
 * "unscrolled" chrome for a frame) and on every subsequent scroll. */
export function useScrolled (threshold: number): boolean {
  const [scrolled, setScrolled] = useState(() =>
    typeof window === 'undefined' ? false : window.scrollY > threshold,
  );

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > threshold);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return scrolled;
}
